import React from 'react';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Span from '@deliveroo/consumer-component-library/components/Span';
import PropTypes from 'prop-types';
import Carousel from '../Carousel';
import Slide from '../Slide';
import FilterShortcut from '../FilterShortcut';
import trackBeforeRedirect from '../../utils/home/trackBeforeRedirect';
import { getTargetURL } from '../../utils/home/factories';
import { SUPPORTED_BLOCKS, SUPPORTED_LAYOUTS, PRELOAD_LIMIT } from '../../utils/home/constants';
import HomeFeedUICard from '../HomeFeedUICard';
import styles from './styles.scss';

const SUPPORTED_CAROUSEL_BLOCKS = [SUPPORTED_BLOCKS.SHORTCUT, SUPPORTED_BLOCKS.CARD];

const HomeFeedCarousel = ({
  result,
  handleGetCollection,
  loading,
  trackTappedLayoutBlock,
  trackTappedLayout,
  getPreloadCount,
}) =>
  result.blocks.some(({ typeName }) => SUPPORTED_CAROUSEL_BLOCKS.includes(typeName)) ? (
    <div>
      {result.header &&
        !loading && (
          <Heading level={3} spacing="0 0 medium 0">
            {result.header}

            {result.targetPresentational && (
              <button
                type="button"
                className={styles.viewAll}
                onClick={() => {
                  handleGetCollection(result.target.queryParams);
                  trackTappedLayout(result.trackingId);
                }}
              >
                <Span color="teal" size="small" spacing="0 0 0 medium">
                  {result.targetPresentational}
                </Span>
              </button>
            )}
          </Heading>
        )}
      <Carousel
        id={`carousel-${result.key}`}
        controlOffsetY={-8}
        controlOffsetX={['-1%', '-3%']}
        slideBy={4}
      >
        {result.blocks
          .map((block) => {
            if (block.typeName === SUPPORTED_BLOCKS.SHORTCUT) {
              const shortcut = {
                name: block.name,
                onClick: () => {
                  handleGetCollection(block.target.queryParams);
                  trackTappedLayoutBlock({
                    layoutTrackingId: result.trackingId,
                    blockTrackingId: block.trackingId,
                  });
                },
                target: block.target,
                images: block.images,
              };
              return (
                <Slide id={block.key} key={block.key} disableOpacity>
                  <FilterShortcut {...shortcut} isPlaceholder={loading} />
                </Slide>
              );
            }

            if (block.typeName === SUPPORTED_BLOCKS.CARD) {
              const url = getTargetURL(block.target);
              const preloadCount = getPreloadCount();
              return (
                <Slide id={block.key} key={block.key} disableOpacity>
                  <HomeFeedUICard
                    {...block}
                    url={url}
                    isPlaceholder={loading}
                    preLoad={preloadCount <= PRELOAD_LIMIT}
                    theme={block.theme === 'CARD_SMALL' ? 'CARD_SMALL' : 'CARD_MEDIUM'} // A card can only be small or medium in a carousel
                    isCardStyle
                    onClick={(e) => {
                      trackBeforeRedirect(e, url, () => {
                        trackTappedLayoutBlock({
                          layoutTrackingId: result.trackingId,
                          blockTrackingId: block.trackingId,
                        });
                      });
                    }}
                  />
                </Slide>
              );
            }
            return null;
          })
          .filter(Boolean)}
      </Carousel>
    </div>
  ) : null;

HomeFeedCarousel.propTypes = {
  result: PropTypes.shape({
    header: PropTypes.string,
    targetPresentational: PropTypes.string,
    key: PropTypes.string.isRequired,
    typeName: PropTypes.oneOf([SUPPORTED_LAYOUTS.CAROUSEL]).isRequired,
    blocks: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  handleGetCollection: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  trackTappedLayoutBlock: PropTypes.func.isRequired,
  trackTappedLayout: PropTypes.func.isRequired,
  getPreloadCount: PropTypes.func,
};

HomeFeedCarousel.defaultProps = {
  loading: false,
  getPreloadCount: () => {},
};

export default HomeFeedCarousel;
